import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  enforceBrowserSessionGate,
  revokeUnacknowledgedServerSession,
  buildLoginRedirectTarget,
} from "../utils/browserSessionGuard";
import { getCleanPath, isPublicPath } from "../utils/publicPaths";
import { isSessionAcknowledged } from "../utils/sessionGate";

function BrowserSessionGate() {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const runGate = async () => {
      const result = await enforceBrowserSessionGate(location.pathname, location.search);
      if (!cancelled && result.forceLogin && result.redirectTo) {
        window.location.replace(result.redirectTo);
      }
    };

    runGate();
    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handlePageShow = (event) => {
      if (!event.persisted || isSessionAcknowledged()) {
        return;
      }

      const cleanPath = getCleanPath(location.pathname);
      if (isPublicPath(cleanPath) || cleanPath === "/login") {
        return;
      }

      const redirectTo = buildLoginRedirectTarget(location.pathname, location.search);
      if (!redirectTo) {
        return;
      }

      revokeUnacknowledgedServerSession().then(() => {
        window.location.replace(redirectTo);
      });
    };

    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, [location.pathname, location.search]);

  return null;
}

export default BrowserSessionGate;
